import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject, fromEvent } from 'rxjs'
import { debounceTime, map, pluck } from 'rxjs/operators';
// import { Events } from '@ionic/angular';
import { EventService } from './event.service';
// import { EventMessages } from '../providers/state/state.provider'

@Injectable()
export class WindowService {
  height$: Observable<number>
  width$: Observable<number>

  constructor(private eventService: EventService) {
    const windowSize$ = new BehaviorSubject(getWindowSize())

    this.height$ = windowSize$.pipe(pluck('height'))
    this.width$ = windowSize$.pipe(pluck('width'))

    fromEvent(window, 'resize').pipe(
      map(getWindowSize),
      debounceTime(200)
    ).subscribe(windowSize$)

    fromEvent(window, 'load').subscribe(() => {
      const token = localStorage.getItem('token')
      if (!token) {
        this.eventService.publishLoggedOut();
        // this.events.publish(EventMessages.loggedOut)
      }
    })
  }

}

function getWindowSize() {
  return {
    height: window.innerHeight,
    width: window.innerWidth
  }
}
